import { render, staticRenderFns } from "./ReportSalesOrders.vue?vue&type=template&id=adfb3410"
import script from "./ReportSalesOrders.vue?vue&type=script&lang=js"
export * from "./ReportSalesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports